import * as tslib_1 from "tslib";
import { EditableField } from '../editable_field';
var InputField = /** @class */ (function (_super) {
    tslib_1.__extends(InputField, _super);
    function InputField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'placeHolder,format,validation,defaultValue,value';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    InputField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "InputField",
            "placeHolder": this.placeHolder,
            "format": this.format,
            "validation": this.validation,
            "defaultValue": this.defaultValue,
            "value": this.value
        });
    };
    InputField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return InputField;
}(EditableField));
export { InputField };
//# sourceMappingURL=input_field.js.map